export default __webpack_public_path__ + "locales/sk/Payments.json?hash=ff03be876b3de1c20aeb58f234cd320a";